
    const overview = `
    <ul class='overview'>
        <li>physicist</li>
        <li>lifelong learner</li>
        <li>educator</li>
        <li>climate wonk</li>
        <li>dog dad</li>
        <li>uncle</li>
    </ul>
    <a href='/#/portfolio'>See my portfolio</a>
`;
export default overview;